import React from 'react'

const SelectionQuantityControl = ({ label, quantity, maxQuantity, onQuantityChange, className = '' }) => {
    if (!maxQuantity || maxQuantity <= 1) return null

    return (
        <div className={`quantity-control justify-content-between ${className}`}>
            <span>{label}</span>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                <i
                    className={`bx bx-minus-circle icon ${quantity === 1 && 'disabled'}`}
                    onClick={() => {
                        if (quantity > 1) {
                            onQuantityChange(Math.max((quantity || 1) - 1, 1))
                        }
                    }}
                />
                <span className="quantity">{quantity || 1}</span>
                <i
                    className={`bx bx-plus-circle icon ${quantity === maxQuantity && 'disabled'}`}
                    onClick={() => {
                        if (quantity < maxQuantity) {
                            onQuantityChange(Math.min((quantity || 1) + 1, maxQuantity))
                        }
                    }}
                />
            </div>
        </div>
    )
}

export default SelectionQuantityControl
